import React from 'react';

import { Box, Image } from '@chakra-ui/react';

import HrisPlugin from 'assets/assetsV1/illustrations/HRISPlugin.png';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { NumberIconSteps, StepCard } from '../commonComponents';

const InstallationSection = () => (
  <StepCard
    title="Installation Steps"
    rightComp={
      <Box border="1px solid" borderColor="feedback.E7DAFF" borderRadius="8px" overflow="hidden" width="45%">
        <Image src={HrisPlugin} objectFit="cover" width="100%" height="100%" />
      </Box>
    }
  >
    <Box>
      <NumberIconSteps
        stepsComps={[
          <TextBodyMedium>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Click the <b>"Install"</b> button.
          </TextBodyMedium>,

          <TextBodyMedium>
            Choose the appropriate HRIS that you wish to <b>connect</b> to.
          </TextBodyMedium>,

          <TextBodyMedium>
            <b>Login</b> and grant permissions.
          </TextBodyMedium>,

          <TextBodyMedium>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            To ensure a successful integration, please <b>remember</b> to <b>click</b> the <b>"Close window"</b> button
            once integration is complete.
          </TextBodyMedium>,
        ]}
      />
    </Box>
  </StepCard>
);

export { InstallationSection };
